import React from 'react'
import _ from 'lodash/fp'
import moment from 'moment'

import { ArrowDropDownCircleOutlined as ShowMoreIcon } from '@material-ui/icons'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { withStyles } from '@material-ui/core'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

import colors from '@fe/ui/colors'

import SimpleScoreCard from './ScoreCard'

export const styles = (theme) => ({
  background: {
    height: 'calc(100vh - 64px)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flexDirection: 'column'
  },
  scorecard: {
    margin: 24,
    marginBottom: 24
  },
  icon: {
    fontSize: '3em',
    margin: 24,
    cursor: 'pointer'
  },
  smallIcon: {
    fontSize: '3em',
    margin: 0,
    cursor: 'pointer'
  },
  bigInfoText: {
    fontSize: '2em',
    [theme.breakpoints.up('md')]: {
      fontSize: '3em'
    }
  },
  smallInfoText: {
    fontSize: '1em',
    [theme.breakpoints.up('md')]: {
      fontSize: '2em'
    }
  }
})

const scrollDown = () => {
  window.scrollTo({ top: window.innerHeight - 64, behavior: 'smooth' })
}

export const ScrollDownButton = withStyles(styles)(
  props => (
    <div
      onClick={scrollDown}
      style={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        color: 'white'
      }}
    >
      <ShowMoreIcon className={props.classes.icon} />
      More details below
    </div>
  )
)

const infoText = { textAlign: 'right', textShadow: '1px 1px 5px black' }

export const Info = ({ club, guide, date, player, classes, handicap }) => (
  <div style={{ display: 'flex', flexDirection: 'column', color: 'white', alignItems: 'flex-end', margin: 12 }}>
    <Typography style={infoText} className={classes.bigInfoText} color='inherit'>{player && player.name}</Typography>
    <Typography style={infoText} className={classes.smallInfoText} color='inherit'>{club && club.name}</Typography>
    <Typography style={infoText} className={classes.smallInfoText} color='inherit'>{handicap && `Course handicap ${handicap}`}</Typography>
    <Typography style={infoText} className={classes.smallInfoText} color='inherit'>{guide && guide.title}</Typography>
    <Typography style={infoText} className={classes.smallInfoText} color='inherit'>{date && moment(date).format('l')}</Typography>
  </div>
)

const Landing = ({ club, holes, guide, date, player, classes, width }) => {
  if (!club) {
    return false
  }
  const gradient = isWidthUp('md', width)
    ? `linear-gradient(0deg, ${colors.primaryDarkGreen} 0%, rgba(255,255,255,0) 38%)`
    : `linear-gradient(0deg, ${colors.primaryDarkGreen} 10%, rgba(255,255,255,0) 50%)`
  return (
    <div
      className={classes.background}
      style={{
        background: `${gradient}`
      }}
    >
      <Grid container style={{ height: '100%' }}>
        <Grid item xs={12}>
          <Info classes={classes} club={club} guide={guide} date={date} player={player} />
        </Grid>
        <Hidden mdDown>
          <Grid item xs={false} md={2} style={{ display: 'flex', alignItems: 'flex-end', color: 'white' }}>
            <ScrollDownButton />
          </Grid>
        </Hidden>
        <Grid item xs={12} lg={10} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <SimpleScoreCard className={classes.scorecard} holes={holes} />
        </Grid>
      </Grid>
    </div>
  )
}

export default _.compose(
  withStyles(styles),
  withWidth()
)(Landing)
